document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[id^="GalleryThumbnails-"] .thumbnail-list__item').forEach(function (thumbLi) {
    var targetId = thumbLi.getAttribute('data-target');
    var thumbBtn = thumbLi.querySelector('button.thumbnail');

    if (!targetId || !thumbBtn || thumbBtn.dataset.lightboxBound === 'true') return;
    thumbBtn.dataset.lightboxBound = 'true';

    thumbBtn.addEventListener('click', function () {
      var mainItem = document.querySelector('[data-media-id="' + targetId + '"]');
      if (!mainItem) return;

      var openerBtn = mainItem.querySelector('button[aria-haspopup="dialog"]');
      if (openerBtn) {
        openerBtn.click();
      }
    });
  });
});